import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { WarehouseTransferReason } from 'src/app/assabil-kernel/models/entities/control-tables/warehouse-transfer-reason';
import { WarehouseTransferReasonType } from 'src/app/assabil-kernel/models/entities/control-tables/warehouse-transfer-reason-type';
import { Field } from 'src/app/tools/models/dtos/field';
import { WarehouseTransferReasonRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/warehouse-transfer-reason-request';


@Component({
    selector: 'warehouse-transfer-reason-list',
    templateUrl: './warehouse-transfer-reason-list.component.html',
    styleUrls: ['./warehouse-transfer-reason-list.component.scss']
})


export class WarehouseTransferReasonListComponent extends BasePage2<WarehouseTransferReason> {

    // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  warehouseTransferReasons      : WarehouseTransferReason[] = [];
  warehouseTransferReasonTypes  : WarehouseTransferReasonType[] = [];
  // ---------------------------------------------------
  
  // ---------------------------------------------------

  constructor(
      protected toastr                : ToastrService,
      protected router                : Router,
      protected baseService           : BaseService,
      protected leanUtilsService      : LeanUtilsService,
      protected controlTablesService  : ControlTablesService,
      protected location              : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName =  "warehouseTransferReason";
      
  }

//----------------------------------------------------------------------
ngAfterViewInit(){

  let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
  request.strArg1 = this.code;
  request.strArg2 = this.name;

  this.controlTablesService.getList('warehouseTransferReasonType', request).then(result => {
      this.warehouseTransferReasonTypes = result;

      super.ngAfterViewInit();
  })

}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
getRows(): WarehouseTransferReason[] {
    return this.warehouseTransferReasons;
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
saveRow(row: WarehouseTransferReason): Promise<WarehouseTransferReason> {
    let request: WarehouseTransferReasonRequest = new WarehouseTransferReasonRequest(this.controlTablesService.getUserInfo());
    request.warehouseTransferReason = row;
    return this.controlTablesService.save(this.entityName, request);
}
//----------------------------------------------------------------------

  
//----------------------------------------------------------------------
new(){
    let entity : WarehouseTransferReason = new WarehouseTransferReason();
    entity.inserted = true;
    entity.edit = true;
    this.warehouseTransferReasons.push(entity);
    this.warehouseTransferReasons = [...this.warehouseTransferReasons];
  }
//----------------------------------------------------------------------

        
//----------------------------------------------------------------------
loadData() {
  let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
  request.strArg1 = this.code;
  request.strArg2 = this.name;

  this.controlTablesService.getList(this.entityName, request).then(result => {
      this.warehouseTransferReasons = result;
  })
}
// ---------------------------------------------------------------------


//----------------------------------------------------------------------
enrichField(field : Field){
  
  if (field.prop == 'warehouseTransferReasonType') {
      field.lov =   {key : "warehouseTransferReasonTypeCode",  value : "name",  data : this.warehouseTransferReasonTypes } ;
      field.key = 'warehouseTransferReasonTypeCode';
      return;
  }
}
//----------------------------------------------------------------------


}
